import React from 'react';
import { Box, Typography, Paper, Divider, Skeleton } from '@mui/material';
import { alpha } from '@mui/material/styles';

const CategoryPreview = ({ categories }) => {
  if (!categories?.length) {
    return (
      <Box>
        {[1, 2].map((group) => (
          <Box key={group} sx={{ mb: 4 }}>
            <Skeleton width={120} height={20} sx={{ mb: 2 }} />
            <Paper
              elevation={0}
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                overflow: 'hidden'
              }}
            >
              {[1, 2, 3].map((item) => (
                <React.Fragment key={item}>
                  {item > 1 && <Divider />}
                  <Box sx={{ p: 2 }}>
                    <Skeleton width={80} height={16} sx={{ mb: 1 }} />
                    <Skeleton width={160} height={24} />
                  </Box>
                </React.Fragment>
              ))}
            </Paper>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box>
      {categories.map((group) => (
        <Box key={group.id} sx={{ mb: 4 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              color: 'text.secondary',
              mb: 2,
              textTransform: 'uppercase',
              fontSize: '0.75rem',
              letterSpacing: '0.1em'
            }}
          >
            {group.title}
          </Typography>
          <Paper
            elevation={0}
            sx={{
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              overflow: 'hidden',
              '&:hover': {
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
              },
              transition: 'box-shadow 0.3s ease'
            }}
          >
            {group.items.filter(item => !item.isArchived).map((item, itemIndex) => (
              <React.Fragment key={item.id}>
                {itemIndex > 0 && <Divider />}
                <Box
                  sx={{
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    '&:hover': {
                      bgcolor: alpha('#000', 0.02),
                    },
                    transition: 'background-color 0.2s ease'
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
                      {item.title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {item.type.charAt(0).toUpperCase() + item.type.slice(1)}
                    </Typography>
                  </Box>
                </Box>
              </React.Fragment>
            ))}
          </Paper>
        </Box>
      ))}
    </Box>
  );
};

export default CategoryPreview; 